import ServerCommunicator from './ServerCommunicator';
import MutualLoginRequest from '../request/MutualLoginRequest';
import GetStripeSubscriptionRequest from '../request/GetStripeSubscriptionRequest';
import CancelStripeSubscriptionRequest from '../request/CancelStripeSubscriptionRequest'


/**
 * Acts as a Facade to the Tweeter server. All network requests to the server go through
 * this class.
 */
class ServerFacade {
	// Server URL: This is the invoke URL of my API on AWS. It can be found by going to your API in AWS, clicking
	// on stages in the right-side menu, and clicking on the stage you deployed your API to.

	// post
	static async loginUser(loginRequest: MutualLoginRequest): Promise<any> {
		const urlPath = 'auth/login';

		const data = { token: loginRequest.firebaseToken, type: loginRequest.type };
		const request = {
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST',
			body: JSON.stringify(data)
		};
		try {
			return await ServerCommunicator.doRequest(request, urlPath);
		} catch(error) {
			console.log('Caught bad login', data, error);
		}
	}

	// get
	/**
	 * This method sends an endpoint to the server communicator which returns a list stripe subscriptions for a user
	 * @param matchesRequest a request object GetMatchesRequest that will store all the match data
	 */
	 static async getStripeSubscriptions(stripeSubscriptionRequest: GetStripeSubscriptionRequest): Promise<any> {

		// The endpoint path actually will need to be formatted as such: /user/{user_id}/subscriptions
		let urlPath = 'user/' + stripeSubscriptionRequest.user_id + '/subscriptions';

		// find a better solution
		if(stripeSubscriptionRequest.user_id.length > 0){
			const request = {
				headers: {
					'Content-Type': 'application/json',
					'Access-Control-Allow-Origin': 'https://localhost:3000'
				},
				method: 'GET'
			};
	
			return await ServerCommunicator.doRequest(request, urlPath)
				.then((httpResponse) => {
					console.log('http Response in .then block in getMatches', httpResponse);
					return httpResponse;
				})
				.catch((e) => {
					console.log('Catch block in then block',e);
					// return new GetMatchesResult(false, 'fix later', [], '', -1);
				});
		}
	}

	static async cancelStripeSubscription (cancelStripeSubscriptionRequest : CancelStripeSubscriptionRequest) : Promise<any> {
		let urlPath = 'user/' + cancelStripeSubscriptionRequest.user_id + '/cancel-stripe-subscription';

		const data = { cancelAtPeriodEnd: cancelStripeSubscriptionRequest.cancel_at_period_end, receipt: cancelStripeSubscriptionRequest.receipt };

		const request = {
			headers: {
				'Content-Type': 'application/json',
				'Access-Control-Allow-Origin': 'https://localhost:3000'
			},
			method: 'POST',
			body: JSON.stringify(data)
		};

		try {
			return await ServerCommunicator.doRequest(request, urlPath);
		} catch {
			console.log('Caught bad request');
		}
	}
}

export default ServerFacade;
